import { FormikHelpers } from 'formik';

export function handleFormErrors<T>(error: any, formikHelpers: FormikHelpers<T>) {
  const serverErrors = error?.response?.data?.errors;

  if (serverErrors) {
    Object.entries(serverErrors).forEach(([field, messages]) => {
      const message = Array.isArray(messages) ? messages[0] : messages;
      formikHelpers.setFieldError(field as string, message);
    });
  } else {
    console.error('Unexpected error:', error);
  }
}
